import useState from 'states/generics/useState'
import useHttpPost from 'states/generics/useHttpPost'

export default function useSendMessage() {
  const [text, setText] = useState('')
  const [postInProgress, setPostInProgress] = useState(false)

  const sendMessage = async ({ threadId }) => {
    const url = `/chat/thread/${threadId}/send-message`
    const { post } = useHttpPost({ url, sleep: 2000 })
    const realText = text.value.trim()
    if (realText) {
      try {
        setPostInProgress(true)
        const response = await post({ text: realText })
        return response
      } finally {
        setPostInProgress(false)
      }
    }
    return null
  }

  return {
    text,
    setText,
    sendMessage,

    postInProgress,
  }
}
